import { CoaAppWindow } from './types';

export * from './types';

export const windowTyped = (window as unknown) as CoaAppWindow;
